import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

import { FormFieldBase } from './form-field-base';

@Component({
  selector: '[form-field]',
  styles: [`
    mat-form-field {
      width: 100%;
      font-family: inherit !important;
      font-size: inherit !important;
      line-height: inherit !important;
      letter-spacing: inherit !important;
      font-kerning: inherit !important;
      font-weight: inherit !important;
      text-transform: inherit !important;
      color: inherit !important;
      font-style: inherit !important;
      text-decoration: inherit !important;
      text-shadow: inherit !important;
      text-align: inherit !important;
    }

    mat-form-field label {
      font-family: inherit !important;
      font-size: inherit !important;
      line-height: inherit !important;
      letter-spacing: inherit !important;
      font-kerning: inherit !important;
      font-weight: inherit !important;
      text-transform: inherit !important;
      color: inherit !important;
      font-style: inherit !important;
      text-decoration: inherit !important;
      text-shadow: inherit !important;
      text-align: inherit !important;
    }
  `],
  template: `
    <div [formGroup]="formGroup">
      <mat-form-field appearance="outline" [class]="item.uId">
        <mat-label>{{ item.content }}</mat-label>
        <input matInput
               [type]="inputType"
               [formControlName]="formName"
               (keyup)="onKey($event)"
               (input)="onInput($event)"
               [attr.aria-label]="item.content || null"
               [required]="required"
               [attr.maxlength]="maxLength"
               [tabIndex]="item.tabindex"
               [autocomplete]="autocompleteReturn()"
               (ngModelChange)="dataChanged($event)">
        <mat-error *ngIf="invalid">{{ getErrorMessage$() | async | translate }}</mat-error>
      </mat-form-field>

    </div>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class FormFieldComponent extends FormFieldBase {

  autocomplete = 'auto';

  autocompleteReturn() {
    if (this.item?.customOrder == 0) {
      this.autocomplete = 'name';
    } else if (this.item?.customOrder == 1) {
      this.autocomplete = 'tel';
    } else if (this.item?.customOrder == 2) {
      this.autocomplete = 'email';
    }
    return this.autocomplete;
  }

  onInput(event: any) {
    if (this.inputType === 'date') {
      const value = event.target.value || '';
      let [y, m, d] = value.split('-');
      if (y.length > 4) {
        y = y.slice(0, 4);
      }
      if (m.length > 2) {
        m = m.slice(0, 2);
      }
      if (d.length > 2) {
        d = d.slice(0, 2);
      }
      event.target.value = [y, m, d].join('-');
    }
  }
}
